import * as PropTypes from 'prop-types';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import ModalAnchor from 'ui-library/ModalAnchor';
import {getWorkflowDisplayString} from 'workflows/util/WorkflowUtil';

import CreateWorkflowModal from '../modals/CreateWorkflowModal';

interface NewWorkflowButtonProps {
  className?: string;
  workflowTemplateId?: string;
  workflowTemplateVersionId?: string;
}

interface State {
  isCreateWorkflowModalOpen: boolean;
}

class NewWorkflowButton extends React.Component<NewWorkflowButtonProps, State> {
  static propTypes = {
    className: PropTypes.string,
    workflowTemplateId: PropTypes.string,
    workflowTemplateVersionId: PropTypes.string,
  };

  state: State = {
    isCreateWorkflowModalOpen: false,
  };

  _handleCreateNewWorkflow = (): void => {
    this.setState({
      isCreateWorkflowModalOpen: true,
    });
  };

  _handleCloseCreateWorkflowModal = (): void => {
    this.setState({
      isCreateWorkflowModalOpen: false,
    });
  };

  render(): JSX.Element {
    return (
      <div>
        <ModalAnchor open={this.state.isCreateWorkflowModalOpen}>
          {this.state.isCreateWorkflowModalOpen && (
            <CreateWorkflowModal
              initialWorkflowTemplateId={this.props.workflowTemplateId}
              initialWorkflowTemplateVersionId={this.props.workflowTemplateVersionId}
              onRequestClose={this._handleCloseCreateWorkflowModal}
            />
          )}
        </ModalAnchor>
        <Button
          buttonStyle={ButtonStyle.SECONDARY}
          className={this.props.className}
          icon="compose"
          onClick={this._handleCreateNewWorkflow}
          size={ButtonSize.SMALL}
          text={getWorkflowDisplayString('New Legacy Workflow', 'New Workflow')}
        />
      </div>
    );
  }
}

export default NewWorkflowButton;
